import axios from "axios";

import {
	FETCH_PRODUCT,
	CREATE_PRODUCT,
	UPDATE_PRODUCT,
	UPDATE_STATUS_PRODUCT,
} from "constants/ActionTypes";

const AUTH_TOKEN =
	"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJoZWFkZXIiOnsiaWQiOiIwIiwidXNlciI6Ik1hbnVlbEdpbCJ9LCJwYXlsb2FkIjp7ImlhdCI6IjIwMTktMDEtMDEgMDA6MDA6MDAiLCJleHAiOiIyMDIwLTAxLTAxIDAwOjAwOjAwIn19.p_PtmXsDe3l_osPEzb4edkf-M2SCdUVBQBKs8ZAbpn8";
const ROOT_URL = "https://admingreenerapp.crsostenible.com/api/public/api/app/";

export async function createProduct(
	{ name, description, price, videoUrl },
	callback
) {
	const formData = new FormData();
	formData.append("name", name);
	formData.append("description", description);
	formData.append("price", price);
	formData.append("file", videoUrl);

	const config = {
		headers: {
			"Content-Type": "multipart/form-data",

			Authorization: "Bearer " + AUTH_TOKEN,
		},
	};

	const ROUTINES = `product/add`;
	const url = `${ROOT_URL}${ROUTINES}`;
	const request = await axios
		.post(url, formData, config)
		.then((response) => response.data.data);
	return {
		type: CREATE_PRODUCT,
		payload: request,
	};
}
export function fetchProduct() {
	const ROUTINES = "products";
	const request = axios({
		method: "get",
		url: `${ROOT_URL}${ROUTINES}`,
		headers: {
			"Content-Type": "application/json",
			Authorization: "Bearer " + AUTH_TOKEN,
		},
	})
		.then((request) => request.data.data)
		.catch((error) => error);
	return {
		type: FETCH_PRODUCT,
		payload: request,
	};
}

export function updateProduct(
	{ id, name, description, price, videoUrl },
	callback
) {
	const formData = new FormData();
	formData.append("id", id);
	formData.append("name", name);
	formData.append("description", description);
	formData.append("price", price);
	formData.append("file", videoUrl);

	const config = {
		headers: {
			"Content-Type": "multipart/form-data",

			Authorization: "Bearer " + AUTH_TOKEN,
		},
	};

	const ROUTINES = `product/edit`;
	const url = `${ROOT_URL}${ROUTINES}`;
	const request = axios
		.post(url, formData, config)
		.then(function (response) {
			console.log("response", response);
		})
		.then(
			(request) => {
				request;
			},
			(error) => {
				console.log(error);
			},
			function (response) {
				console.log("response", response);
			}
		)
		.then(callback());
	return {
		type: UPDATE_PRODUCT,
		payload: request,
	};
}

export function updateStatusProduct(
	product_id,
	product_status,
	callback = () => console.log()
) {
	const ROUTINES = "product/upate_status";
	const request = axios({
		method: "post",
		url: `${ROOT_URL}${ROUTINES}`,
		data: {
			product_id: product_id,
			status: product_status,
		},
		headers: {
			"Content-Type": "application/json",
			Authorization: "Bearer " + AUTH_TOKEN,
		},
	})
		.then((request) => request.success)
		.then(callback());
	return {
		type: UPDATE_STATUS_PRODUCT,
		payload: request,
	};
}



// WEBPACK FOOTER //
// ./src/appRedux/actions/Product.js